<template>
  <div class="field status">
    <span v-if="label" class="label text-right" :class="labelClass">
      {{ label }}
    </span>

    <span class="value v-align" :class="valueClass">
      <div v-html="this.$options.filters.nl2br(getValue)"></div>
    </span>

  </div>
</template>

<script>
import formatter from '@/components/global/mixins/formatterMethods'

export default {
  props: {
    value: {
      type: [String, Number, Object, Array]
    },
    label: String,
    width: String
  },

  mixins: [formatter],

  computed: {
    valueClass: function () {
      if (this.label) {
        if (this.width === 'large') {
          return 'col-10'
        } else {
          return 'col-8'
        }
      }
    },

    getValue: function () {
      return this.translateStatus(this.value)
    },

    labelClass: function () {
      if (this.width === 'large') {
        return 'col-2'
      } else {
        return 'col-4'
      }
    }
  }
}
</script>
